export default "__VITE_ASSET__DZzTuLT4__"